import React from "react";
import { Link } from "react-router-dom";
import PublicNav from "../../components/layout/PublicNav";
import PublicFooter from "../../components/layout/PublicFooter";

const items = [
  { to: "/legal/privacy", label: "Privacy Policy" },
  { to: "/legal/terms", label: "Terms of Service" },
  { to: "/legal/cookies", label: "Cookie Notice" },
  { to: "/legal/accessibility", label: "Accessibility Statement" },
];

export default function LegalPlaceholder({ title }) {
  return (
    <div className="min-h-screen bg-white" data-testid={`legal-${title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
      <PublicNav />
      <section className="bg-trital-mesh">
        <div className="max-w-[860px] mx-auto px-5 lg:px-8 pt-20 pb-16">
          <nav aria-label="Breadcrumb" className="text-xs text-slate-500 mb-6">
            <Link to="/" className="hover:text-trital-navy">Home</Link>
            <span className="mx-2 text-slate-300">/</span>
            <span className="text-slate-700">Legal</span>
            <span className="mx-2 text-slate-300">/</span>
            <span className="text-slate-700">{title}</span>
          </nav>
          <div className="eyebrow text-trital-red">Legal</div>
          <h1 className="mt-3 font-display font-black text-4xl lg:text-5xl leading-[1.05] text-slate-900 text-balance">{title}</h1>
          <p className="mt-5 text-slate-600 max-w-[62ch]">
            This document is being finalized by our counsel and compliance team. Contact{" "}
            <a href="mailto:info@tritalcare.com" className="text-trital-medical-blue underline-offset-4 hover:underline">info@tritalcare.com</a>{" "}
            for the latest version or specific compliance documentation.
          </p>
        </div>
      </section>
      <section className="section-pad">
        <div className="max-w-[860px] mx-auto px-5 lg:px-8">
          <div className="eyebrow text-trital-red mb-3">Other policies</div>
          <ul className="space-y-2">
            {items.filter((i) => i.label !== title).map((i) => (
              <li key={i.to}>
                <Link to={i.to} className="text-slate-700 hover:text-trital-navy underline-offset-4 hover:underline">
                  {i.label} →
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </section>
      <PublicFooter />
    </div>
  );
}
